import { render } from "./SelectedImagePreview.vue?vue&type=template&id=785f816d&scoped=true"
import script from "./SelectedImagePreview.vue?vue&type=script&lang=js"
export * from "./SelectedImagePreview.vue?vue&type=script&lang=js"

import "./SelectedImagePreview.vue?vue&type=style&index=0&id=785f816d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785f816d"]])

export default __exports__